<template>
  <md-card>
    <md-card-header md-alignment="space-between">
      <h4 class="title">
        <md-icon>assignment</md-icon>
        주요 변동사항
      </h4>
    </md-card-header>
    <md-card-content>
        <div style="height: 500px; overflow-y: auto;">
        <div
            v-for="item in contactList"
            :key="item.id"
            style="padding: 8px 0; border-bottom: 1px solid #eee;"
        >
            <div style="font-size: 11px; color: goldenrod; text-align: right; margin-top: 2px;">
            {{ item.contactPerson }} ({{ item.contactDate }})
            </div>
            <div style="word-break: break-all;">
            {{ item.contents }}
            </div>
        </div>
        </div>
      <table class="flex-table">
        <tr>
          <th style="width: 80px;">연락자</th>
          <td>
            <input type="text" v-model="new1" />
          </td>
        </tr>
        <tr>
          <th style="width: 80px;">일자</th>
          <td>
            <input type="text" v-model="new2" v-mask="'####-##-##'" placeholder="YYYY-MM-DD" />
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <textarea
            v-model="new3"
            rows="3"
            style="width: 100%; resize: both;"
            placeholder="내용을 입력하세요"
            ></textarea>
          </td>
        </tr>
      </table>
      <md-button style="margin-top: 5px; margin-bottom: 5px;"
        class="md-info md-sm"
        @click="saveContactHistory"
        
      >
        <md-icon>check</md-icon>저장
      </md-button>
    </md-card-content>
  </md-card>
</template>

<script>
import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

import Swal from "sweetalert2";

import { MemberSearchPopComp, PostcodePopComp } from "@/pages";

export default {
  name: "DonatorContactHisComp",
  props: {
    donator: {
        type: Object,
        default: null
    }
  },
 watch: {
  donator: {
    handler(newVal) {
      console.log('donator changed:', newVal); // 호출 여부 확인
      if (newVal && newVal.memberNo) {
        this.loadContactHistory(newVal.memberNo);
      }
    },
    immediate: true
  }
},
  data() {
    return {
        new1: '', // 연락자
        new2: '', // 일자
        new3: '', // 내용
        memberNo: null, // 기부자 회원 번호
        contactList: [] // 연락 이력 목록
    };
  },
  methods: {
    
    
  loadContactHistory(memberNo) {
    kuaaApi.sendServer(
      URL_CONST.GET_DONOR_CONTACT_HISTORY,
      { memberNo },
      "post",
      response => {
        if (response.data.success && Array.isArray(response.data.data)) {
          this.contactList = response.data.data;
        } else {
          this.contactList = [];
        }
      }
    );
  },

    saveContactHistory() {
        if (!this.new1) {
        alert('연락자 입력하세요..');
        this.$refs.inputNew1.focus();
        return;
        }
        if (!this.new2) {
        alert('일자 입력하세요.');
        this.$refs.inputNew2.focus();
        return;
        }
        if (!this.new3) {
        alert('내용을 입력하세요.');
        this.$refs.inputNew3.focus();
        return;
        }

        
    const cleanNew2 = this.new2.replace(/[^0-9]/g, '');

        const payload = {
        contactPerson: this.new1,
        contactDate: cleanNew2,
        contents: this.new3,
        memberNo: this.donator.memberNo
        };

        kuaaApi.sendServer(
        URL_CONST.SAVE_DONOR_CONTACT_HISTORY, 
        payload,
        "post",
        response => {
            if (response.data.success) {
            kuaaFnc.showSwal("연락이력", "저장되었습니다.");
            // 저장 후 입력값 초기화
            this.new1 = '';
            this.new2 = '';
            this.new3 = '';
            // 필요시 이력 재조회
            this.loadContactHistory(this.donator.memberNo);
            } else {
            kuaaFnc.showSwal("연락이력", "저장 실패하였습니다.");
            }
        }

        );
    }
    }
  }
</script>
